/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * Since a single logical zone violation event can end up triggering many individual zone violation events to the backend we group events that happened close in time to each other between the same vehicles into a single higher level zone violation incident.
 * 
 * Vehicle zone violation events are aggregated into zone violation incidents in a background worker.
 * @export
 * @interface VehicleZoneViolationIncident
 */
export interface VehicleZoneViolationIncident {
    /**
     * Unique ID for this incident.
     * @type {string}
     * @memberof VehicleZoneViolationIncident
     */
    id: string;
    /**
     * Time at which the zone violation incident started.
     * @type {Date}
     * @memberof VehicleZoneViolationIncident
     */
    startTime: Date;
    /**
     * Time at which the zone violation incident ended.
     * @type {Date}
     * @memberof VehicleZoneViolationIncident
     */
    stopTime: Date;
    /**
     * Vehicle A that triggered this incident.
     * 
     * This is the vehicle with the numerically lower UUID.
     * @type {string}
     * @memberof VehicleZoneViolationIncident
     */
    aVehicleId: string;
    /**
     * Vehicle B that triggered this incident.
     * 
     * This is the vehicle with the numerically higher UUID.
     * @type {string}
     * @memberof VehicleZoneViolationIncident
     */
    bVehicleId: string;
    /**
     * User that was logged in to vehicle A at the time the incident occurred, if any.
     * @type {string}
     * @memberof VehicleZoneViolationIncident
     */
    aUserId?: string | null;
    /**
     * User that was logged in to vehicle B at the time the incident occurred, if any.
     * @type {string}
     * @memberof VehicleZoneViolationIncident
     */
    bUserId?: string | null;
    /**
     * Minimum distance between the two devices in centimeters.
     * @type {number}
     * @memberof VehicleZoneViolationIncident
     */
    minimumDistanceCm: number;
    /**
     * Closest ELOshield zone which was violated during the incident.
     * @type {ProximityZone}
     * @memberof VehicleZoneViolationIncident
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the VehicleZoneViolationIncident interface.
 */
export function instanceOfVehicleZoneViolationIncident(value: object): value is VehicleZoneViolationIncident {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('stopTime' in value) || value['stopTime'] === undefined) return false;
    if (!('aVehicleId' in value) || value['aVehicleId'] === undefined) return false;
    if (!('bVehicleId' in value) || value['bVehicleId'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function VehicleZoneViolationIncidentFromJSON(json: any): VehicleZoneViolationIncident {
    return VehicleZoneViolationIncidentFromJSONTyped(json, false);
}

export function VehicleZoneViolationIncidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleZoneViolationIncident {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'stopTime': (new Date(json['stopTime'])),
        'aVehicleId': json['aVehicleId'],
        'bVehicleId': json['bVehicleId'],
        'aUserId': json['aUserId'] == null ? undefined : json['aUserId'],
        'bUserId': json['bUserId'] == null ? undefined : json['bUserId'],
        'minimumDistanceCm': json['minimumDistanceCm'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function VehicleZoneViolationIncidentToJSON(json: any): VehicleZoneViolationIncident {
    return VehicleZoneViolationIncidentToJSONTyped(json, false);
}

export function VehicleZoneViolationIncidentToJSONTyped(value?: VehicleZoneViolationIncident | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startTime': value['startTime'].toISOString(),
        'stopTime': value['stopTime'].toISOString(),
        'aVehicleId': value['aVehicleId'],
        'bVehicleId': value['bVehicleId'],
        'aUserId': value['aUserId'],
        'bUserId': value['bUserId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

